import React, { useState } from 'react'
import {
  Table,
  Form,
  Spin,
  Row,
  Divider,
  Col,
  Select,
  Typography,
  Tooltip,
  Button,
  Modal,
  Input,
  InputNumber,
  Space
} from 'antd';
import { FlagOutlined,   EditOutlined, DeleteOutlined, FolderOpenOutlined } from "@ant-design/icons";
import Notiflix from "notiflix";

import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig, } from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import { accountStatus } from '../../../../../../components/facilities/AccountFacility';

const { Text } = Typography

const Charges = (props) => {

  const { chargesList, state, userData, refreshNote, refreshDetail } = props;
  const { session } = userData;
  const [isLoading, setIsLoading] = useState(false);

    const handleChargeDelete = (key) => {
      let action = "Delete  ";
      let label = BOM.SubstringFormat(key.name, 20);
  
      Notiflix.Confirm.show(
        "Are you sure?",
        action + label,
        "Yes",
        "No",
  
        function () {
          // Yes
          const url = `${apiConfig.LoanAccounts}/${state.id}/charges/${key.id}`;
  
          const body = {
            method: "DELETE",
            session,
          };
  
          setIsLoading(true);
  
          BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteChargeMsg);
              //refresh the list
              refreshDetail();
              refreshNote();
              //STOP LOAD
              setIsLoading(false);
            }
          });
        },
        function () {
          // No button
        }
      );
    };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Fee/Penalty",
      dataIndex: "penalty",
    },
    {
      title: "Payment Due At",
      dataIndex: "paymentDueAt",
    },
    {
      title: "Due As Of",
      dataIndex: "dueAsOf",
    },
    {
      title: "Calculation Type",
      dataIndex: "calculationType",
    },
    {
      title: "Due",
      dataIndex: "due",
    },
    {
      title: "Paid",
      dataIndex: "paid",
    },
    {
      title: "Waived",
      dataIndex: "waived",
    },
    {
      title: "Outstanding",
      dataIndex: "outstanding",
    },
    {
      title: "Actions",
      render: (_, record) =>
        state.statusValue.toLowerCase() ===
          accountStatus.submittedAndPending ? (
          <>
            <DetailCharge
              currentCustomerObj={state}
              userData={userData}
              chargeObj={record}
              refreshDetail={refreshDetail}
              refreshNote={refreshNote}
            />
            &nbsp;
            {BOM.HasPermission("UPDATE_LOANCHARGE") && <EditCharge
              currentCustomerObj={state}
              userData={userData}
              chargeObj={record}
              refreshDetail={refreshDetail}
              refreshNote={refreshNote}
            />}
            &nbsp;
            {BOM.HasPermission("DELETE_LOANCHARGE") && <Tooltip title={`Remove Charge`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleChargeDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>}
          </>
        ) : state.statusValue.toLowerCase() === accountStatus.approved ? (
          <DetailCharge
            currentCustomerObj={state}
            userData={userData}
            chargeObj={record}
            refreshDetail={refreshDetail}
            refreshNote={refreshNote}
          />
        ) : (
          <>
            <DetailCharge
              currentCustomerObj={state}
              userData={userData}
              chargeObj={record}
              refreshDetail={refreshDetail}
              refreshNote={refreshNote}
            />
            {/* &nbsp;
            {BOM.HasPermission("WAIVE_LOANCHARGE") &&
              <WaiveChargeModal
                state={state}
                userData={userData}
                objParam={record}
              />} */}
          </>
        ),
    }
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={chargesList}
      />
    </>
  )
}

export default Charges

const DetailCharge = (props) => {
  const {
    currentCustomerObj,
    userData,
    chargeObj,
    refreshDetail,
    refreshNote,
  } = props;

  const { session } = userData;
  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [chargeDetail, setChargeDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.LoanAccounts}/${currentCustomerObj.id}/charges/${chargeObj.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setChargeDetail(objDetail);

        setInputField([
          {
            name: labelConfig.name,
            value: objDetail?.name
              ? BOM.SubstringFormat(objDetail?.name, 20)
              : "-",
            type: "general",
          },
          {
            name: labelConfig.charge,
            value: objDetail?.penalty ? "Penalty" : "Fees",
            type: "general",
          },

          {
            name: labelConfig.currency,
            value: objDetail?.currency ? objDetail?.currency?.name : "-",
            type: "general",
          },
          {
            name: labelConfig.paymentDueAt,
            value: objDetail.chargeTimeType
              ? objDetail.chargeTimeType?.value
              : "-",
            type: "general",
          },
          {
            name: labelConfig.paymentDueAsOf,
            value: objDetail.dueDate
              ? BOM.DateTime(objDetail?.dueDate, "only-date")
              : "-",
            type: "general",
          },

          {
            name: labelConfig.calculationType,
            value: objDetail?.chargeCalculationType
              ? objDetail?.chargeCalculationType?.value
              : "-",
            type: "general",
          },
          {
            name: labelConfig.due,
            value: `${objDetail?.currency?.code ? objDetail?.currency?.code : "-"
              } ${objDetail?.amount
                ? objDetail?.amount
                : "0.00"
              }`,
            type: "general",
          },
          {
            name: labelConfig.paid,
            value: `${objDetail?.currency?.code ? objDetail?.currency?.code : "-"
              } ${objDetail?.amountPaid ? objDetail?.amountPaid : "0.00"}`,
            type: "general",
          },
          {
            name: labelConfig.waived,
            value: `${objDetail?.currency?.code ? objDetail?.currency?.code : "-"
              } ${objDetail?.amountWaived ? objDetail?.amountWaived : "0.00"}`,
            type: "general",
          },
          {
            name: labelConfig.outstanding,
            value: `${objDetail?.currency?.code ? objDetail?.currency?.code : "-"
              } ${objDetail?.amountOutstanding
                ? objDetail?.amountOutstanding
                : "0.00"
              }`,
            type: "general",
          },
        ]);

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function handleWaiveCharge() {
    let action = "Waive  ";
    let label = chargeDetail.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        const params = {
          command: "waive",
        };
        const url = `${apiConfig.LoanAccounts}/${currentCustomerObj.id}/charges/${chargeDetail.id}`;
        const body = {
          method: "POST",
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          session,
          params,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.waivedChargeMsg);
            setIsModalOpen(false);
            refreshDetail();
            refreshNote();

            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  }

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Charge Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Space size="small">
                {currentCustomerObj.statusValue.toLowerCase() === accountStatus.active ? BOM.HasPermission("WAIVE_LOANCHARGE") && <Button
                  type="primary"
                  shape="round"
                  icon={<FlagOutlined />}
                  className="of-primaryBtnColor"
                  onClick={() => handleWaiveCharge(chargeDetail)}
                  danger={true}
                >
                  Waive Charge
                </Button> : null}

                {/* {BOM.HasPermission("INACTIVATE_SAVINGSACCOUNTCHARGE") && <Button
                  type="primary"
                  shape="round"
                  className="of-primaryBtnColor"
                >
                  Inactivate Charge
                </Button>} */}
              </Space>
            </div>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

const EditCharge = (props) => {
  const {
    currentCustomerObj,
    userData,
    chargeObj,
    refreshDetail,
    refreshNote,
  } = props;

  const { session } = userData;
  const { Text } = Typography;
  const { TextArea } = Input;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [chargesList, setChargesList] = useState([]);
  const [chargeDetail, setChargeDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getTemplate = () => {
    const url = `${apiConfig.LoanAccounts}/${currentCustomerObj.id}/charges/${chargeObj.id}`;

    let body = {
      session,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempArray = [];
        setChargeDetail(objList);

        useForm.setFieldsValue({
          amount: objList.amount,
        });

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getTemplate();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onEditCharge = (formValues) => {
    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "PUT",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      `${apiConfig.LoanAccounts}/${currentCustomerObj.id}/charges/${chargeObj.id}`,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editChargeMsg);
          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshDetail();
          refreshNote();

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  return (
    <>
      <Tooltip title={`Edit Charge`}>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Edit Charge"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onEditCharge}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row style={{ justifyContent: "space-betwen" }}>
            <Divider orientation="left">{labelConfig.chargeInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="amount"
                label={<Text>{labelConfig.amount}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.amount),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

// const WaiveChargeModal = (props) => {
//   const { state, userData, objParam } = props;

//   const { session } = userData;

//   const [useForm] = Form.useForm();
//   const [installmentChargeOptions, setInstallmentChargeOptions] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   function getTemplate() {
//     const url = `${apiConfig.LoanAccounts}/${state.id}/charges/${objParam.id}`;

//     let body = {
//       session,
//     };

//     setIsLoading(true);
//     BOM.FetchReqAction(body, url, (err, res) => {
//       if (err) {
//         BOM.AlertMsg(cnt.DANGER, err);
//         setIsLoading(false);
//       } else {
//         const objDetail = res;
//         let tempInstallmentChargeArray = [];

//         objDetail?.installmentChargeData.forEach((element) => {
//           tempInstallmentChargeArray.push({
//             value: element.installmentNumber,
//             label: element.installmentNumber,
//           });
//         });

//         setInstallmentChargeOptions(tempInstallmentChargeArray);

//         setIsLoading(false);

//       }
//     });
//   }

//   const showModal = () => {
//     setIsModalOpen(true);
//     getTemplate();
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//   };

//   const onSubmit = (formValues) => {
//     const params = {
//       command: "waive",
//     };
//     const url = `${apiConfig.Loans}/${state.id}/charges/${objParam.id}`;

//     const body = {
//       ...formValues,
//       locale: "en",
//       method: "POST",
//       session,
//       params,
//     };

//     // console.log(body); return
//     setIsLoading(true);
//     BOM.FetchReqAction(body, url, (err, res) => {
//       if (err) {
//         BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
//         setIsLoading(false);
//       } else {
//         BOM.AlertMsg(cnt.SUCCESS, labelConfig.waiveChargeMsg);

//         // close modal
//         setIsModalOpen(false);

//         //STOP LOAD
//         setIsLoading(false);
//       }
//     });
//   };

//   return (
//     <>
//       <Tooltip title={`Waive Charge`}>
//         <Button
//           type="primary"
//           icon={<FlagOutlined />}
//           onClick={showModal}
//           shape="round"
//           size="small"
//           className="of-primaryBtnColor"
//         />
//       </Tooltip>
//       <Modal
//         title="Waive Loan Charge"
//         open={isModalOpen}
//         okText="Submit"
//         cancelText="Cancel"
//         okButtonProps={{
//           autoFocus: true,
//           htmlType: "submit",
//           style: {
//             ...styles.ofPrimaryBtnColor,
//           },
//         }}
//         centered
//         onCancel={handleCancel}
//         width={800}
//         modalRender={(dom) => (
//           <Form layout="vertical" form={useForm}
//             onFinish={onSubmit}
//           >
//             {dom}
//           </Form>
//         )}
//         style={{
//           height: 600,
//           overflow: "auto",
//         }}
//       >
//         <Spin spinning={isLoading} tip="Loading..." size="large">
//           <Row>
//             <Col span={8} style={{ padding: "0px 8px" }}>
//               <Form.Item
//                 disabled
//                 label={labelConfig.installmentNumber}
//                 name="installmentNumber"
//               >
//                 <Select
//                   filterOption={(input, option) =>
//                     (option?.label?.toLowerCase() ?? "").includes(
//                       input?.toLowerCase()
//                     )
//                   }
//                   placeholder={BOM.handlePlaceholderMsg(
//                     `${labelConfig.installmentNumber} *`,
//                     "select"
//                   )}
//                   options={installmentChargeOptions}
//                   showSearch
//                 />
//               </Form.Item>
//             </Col>
//           </Row>
//         </Spin>
//       </Modal>
//     </>
//   );
// };